import { CheckboxGroup as RadixCheckboxGroup } from '@radix-ui/themes';

export const CheckboxGroup = RadixCheckboxGroup;
export type CheckboxGroupRootProps = RadixCheckboxGroup.RootProps;
export type CheckboxGroupItemProps = RadixCheckboxGroup.ItemProps;
